import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import './InboxPage.css';

const CloseIcon = () => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M18 6L6 18M6 6L18 18" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);

const PlusIcon = () => (
  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M12 5V19M5 12H19" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);

const RemoveIcon = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M18 6L6 18M6 6L18 18" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);

function InboxPage() {
  const [billingYearly, setBillingYearly] = useState(false);
  const [users, setUsers] = useState([
    { id: 1, name: 'Ontraport Product Team Projects', email: 'productteam+projects@ontraport.com' }
  ]);

  const removeUser = (id) => {
    setUsers(users.filter(user => user.id !== id));
  };

  const userCount = users.length;
  const pricePerUser = 99;
  const totalPrice = userCount * pricePerUser;

  return (
    <div className="inbox-page">
      {/* Header */}
      <header className="inbox-header">
        <Link to="/" className="close-button">
          <CloseIcon />
        </Link>
        <h1 className="header-title">Change plan</h1>
      </header>

      {/* Main Content */}
      <main className="inbox-main">
        <div className="inbox-content">
          {/* Left Section - Users Table */}
          <div className="inbox-users-section">
            <h2 className="inbox-title">Inbox</h2>
            
            <div className="manage-users-header">
              <span className="manage-users-label">Manage users</span>
              <button className="add-user-btn">
                <PlusIcon />
                <span>ADD</span>
              </button>
            </div>

            <div className="users-table-container">
              <table className="users-table">
                <thead>
                  <tr>
                    <th>NAME</th>
                    <th>EMAIL</th>
                    <th></th>
                  </tr>
                </thead>
                <tbody>
                  {users.map((user) => (
                    <tr key={user.id}>
                      <td>{user.name}</td>
                      <td>{user.email}</td>
                      <td>
                        <button 
                          className="remove-user-btn"
                          onClick={() => removeUser(user.id)}
                        >
                          <RemoveIcon />
                        </button>
                      </td>
                    </tr>
                  ))}
                  {users.length === 0 && (
                    <tr>
                      <td colSpan="3" className="no-users">No users added</td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          </div>

          {/* Right Section - Sidebar */}
          <aside className="inbox-sidebar">
            <div className="sidebar-card">
              {/* Inbox Users Count */}
              <div className="sidebar-option users-count-row">
                <div className="option-label-col">
                  <span className="option-label">Inbox Users</span>
                  <span className="option-sublabel">$99 per user per month</span>
                </div>
                <span className="users-count">{userCount}</span>
              </div>

              {/* Billed yearly */}
              <div className="sidebar-option">
                <div className="option-label-col">
                  <span className="option-label">Billed yearly</span>
                  <span className="option-sublabel">Get 2 months free</span>
                </div>
                <button 
                  className="option-toggle-btn"
                  onClick={() => setBillingYearly(!billingYearly)}
                >
                  <span>Add</span>
                  <span className={`toggle-track ${billingYearly ? 'active' : ''}`}></span>
                </button>
              </div>

              {/* Price Display */}
              <div className="price-display">
                <div className="price-main">
                  <span className="price-currency">$</span>
                  <span className="price-amount">{totalPrice}</span>
                  <span className="price-period">per month</span>
                </div>
              </div>

              <button className="change-plan-btn">Change plan</button>

              <p className="tax-note">Subject to local sales tax rates based on your billing address.</p>

              <a href="#" className="cancel-link">Cancel Inbox</a>
            </div>
          </aside>
        </div>
      </main>
    </div>
  );
}

export default InboxPage;
